function AuditedIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color="brand.textColor"
    >
      <path
        d="M6.66602 8L7.66602 9L9.66602 7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33398 7.178C2.33399 10.1284 4.16545 12.7688 6.92884 13.8024L6.94888 13.8099C7.62723 14.0636 8.37447 14.0634 9.05265 13.8092L9.06889 13.8031C11.8348 12.7666 13.6673 10.1228 13.6673 7.16909V4.68682C13.6673 4.10357 13.2882 3.58801 12.7315 3.41412L8.39817 2.06064C8.13933 1.97979 7.86199 1.97979 7.60314 2.06064L3.26981 3.41408C2.71308 3.58797 2.33398 4.10353 2.33398 4.68678V7.178Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default AuditedIcon;
